import {useEffect, useState} from "react";
import {UserService} from "./Service";
import toast from "react-hot-toast";

const AddUser = () => {
    const [userService] = useState(new UserService()); // [state, setState
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    // Generate a random password
    const generatePassword = () => {
        const length = 8;
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        let retVal = "";
        for (let i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        setPassword(retVal);
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const data = {
            name,
            email,
            password,
        };
        const res = await userService.add(data);
        if (res) {
            e.target.reset();
            generatePassword();
            setEmail('');
            setName('');
            setLoading(false);
            toast.success("User added successfully", {});
        }
    }

    useEffect(() => {
        generatePassword();
    }, []);


    return (
        <>
            <div className="card">
                <div className="card-header p-3">
                    <h5 className="card-title">Add User</h5>
                </div>
                <div className="card-body">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Full Name <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="name" name="name" placeholder="Name" value={name}
                                           onChange={(e) => setName(e.target.value)} required={true}/>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Email <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="email" className="form-control" id="email" name="email" placeholder="Email" value={email}
                                           onChange={(e) => setEmail(e.target.value)} required={true}/>
                                </div>
                            </div>

                            <div className="col-sm-12 col-md-4">
                                <div className="mb-3">
                                    <label htmlFor="title" className="form-label">Password <span
                                        className='text-danger'>(required)</span></label>
                                    <input type="text" className="form-control" id="password" name="password" placeholder="Password" value={password}
                                           onChange={(e) => setPassword(e.target.value)} required={true}/>
                                </div>
                            </div>

                        </div>

                        <div className={'d-flex'}>
                            <button type="submit" className="btn btn-primary me-2" disabled={loading}>{loading &&
                                <span className="spinner-border spinner-border-sm me-2" role="status"/>} Submit
                            </button>
                            <button type="button" className="btn btn-secondary me-2" disabled={loading} onClick={() => {
                                window.history.back();
                            }}>{loading &&
                                <span className="spinner-border spinner-border-sm me-2" role="status"/>} Back
                            </button>
                        </div>

                    </form>

                </div>
            </div>
        </>
    );
}


export default AddUser;
